/**
 * Shared location filter for Muster Report + Attendance Report.
 * `value` is sent as API query `locationKey` — must match backend allowlist.
 */
export const REPORT_LOCATION_KEYS = {
  TORRENT_POWER: "torrent_power",
  YOGA_GARDEN: "yoga_garden",
  MOON_PARK: "moon_park",
  SABARMATI_RIVERFRONT: "sabarmati_riverfront",
};

export const REPORT_LOCATION_OPTIONS = [
  { value: "", label: "All Locations" },
  { value: REPORT_LOCATION_KEYS.TORRENT_POWER, label: "TORRENT POWER" },
  { value: REPORT_LOCATION_KEYS.YOGA_GARDEN, label: "Yoga Garden" },
  { value: REPORT_LOCATION_KEYS.MOON_PARK, label: "Moon Park" },
  {
    value: REPORT_LOCATION_KEYS.SABARMATI_RIVERFRONT,
    label: "Sabarmati Riverfront Ahmedabad",
  },
];

const PATTERNS = {
  [REPORT_LOCATION_KEYS.TORRENT_POWER]: /torrent[\s,.-]*power/i,
  [REPORT_LOCATION_KEYS.YOGA_GARDEN]: /yoga[\s,.-]*garden/i,
  [REPORT_LOCATION_KEYS.MOON_PARK]: /moon[\s,.-]*park/i,
  [REPORT_LOCATION_KEYS.SABARMATI_RIVERFRONT]: /sabarmati[\s,.-]*riverfront/i,
};

export function attendanceAddressMatchesLocationKey(address, locationKey) {
  if (!locationKey) return true;
  const re = PATTERNS[locationKey];
  if (!re) return true;
  return re.test(String(address || ""));
}
